import React from 'react';

const Error404 = () => {
  return (
    <section className="bg-soft">
      <div className="overlay">Error 404</div>
    </section>
  );
};

export default Error404;
